<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <h6 class="mb-0 me-auto">Ventas</h6>
              <div class="d-flex align-items-center gap-2">
                <button class="btn btn-sm btn-success" @click="exportToExcel" title="Exportar a Excel">
                  <i class="fas fa-file-excel me-1"></i> Exportar Excel
                </button>
                <router-link
                  :to="{ name: 'Remissions Create', query: { type: 'quote' } }"
                  class="btn btn-sm btn-warning text-white"
                  title="Cotizar"
                >
                  <i class="fas fa-file-signature me-1"></i> Cotizar
                </router-link>
              </div>
            </div>

            <div class="row">
              <!-- Columna de búsqueda -->
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar remisión..." @input="debouncedFetchData" />
              </div>
              <div class="col-md-4 mb-3">
                <label for="startDate" class="mb-1">Desde</label>
                <input
                  id="startDate"
                  type="date"
                  v-model="startDate"
                  class="form-control"
                  @change="fetchData(null)"
                />
              </div>
              <div class="col-md-4 mb-3">
                <label for="endDate" class="mb-1">Hasta</label>
                <input
                  id="endDate"
                  type="date"
                  v-model="endDate"
                  class="form-control"
                  @change="fetchData(null)"
                />
              </div>
            </div>

          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      N°</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Nombre</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Email</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Teléfono</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Observación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Total</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Pagado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Fecha</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.email }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <h6 class="mb-0 text-sm">{{ value.phone }}</h6>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2, maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="paidBadgeClass(value.paid)">
                        {{ paidBadgeLabel(value.paid) }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-warning': value.status == 0,
                        'bg-gradient-success': value.status == 1
                      }">
                        {{ value.status == 0 ? 'Borrador' : 'Formalizada' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.created_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">

                      <a
                        href="#"
                        @click.prevent="openPosTicket(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                        title="Abrir ticket de venta (nueva ventana)"
                      >
                        <i class="fa fa-print"></i>
                      </a>
                    
                      <router-link
                        v-if="Number(value.status) === 1"
                        :to="{ name: 'Remissions Create', query: { id: value.id } }"
                        class="text-secondary font-weight-bold text-xs"
                        title="Ver detalles"
                        style="margin-left: 15px;"
                      >
                        <i class="fa fa-eye"></i>
                      </router-link>

                      <router-link
                        v-if="Number(value.status) !== 1"
                        :to="{ name: 'Remissions Create', query: { id: value.id } }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro" style="margin-left: 15px;">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>

                      <a v-if="Number(value.status) !== 1" @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="10" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                  <tr v-if="data.length > 0" class="bg-light">
                    <td colspan="5" class="text-end text-sm fw-bold">Total (todas las páginas filtradas):</td>
                    <td class="align-middle text-center">
                      <span class="text-success text-sm fw-bold">
                        {{ totalFilteredAllPages.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </span>
                    </td>
                    <td colspan="4"></td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import debounce from '@/utils/debounce';


export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      startDate: '',
      endDate: '',
      totalFilteredAllPages: 0,
    };
  },

  computed: {
    ...mapGetters('remissions', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.remissions.currentPage;
    },
    lastPage() {
      return this.$store.state.remissions.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['remissions/links'];
    },
  },
  methods: {
    isRemissionPaid(paid) {
      return paid === true || paid === 1 || paid === '1';
    },
    paidBadgeLabel(paid) {
      return this.isRemissionPaid(paid) ? 'Pagado' : 'No pagado';
    },
    paidBadgeClass(paid) {
      return this.isRemissionPaid(paid) ? 'bg-gradient-success' : 'bg-gradient-danger';
    },
    async fetchData(pageUrl = null) {
      let page = 1;
      if (pageUrl) {
        try {
          page = new window.URL(pageUrl).searchParams.get("page") || 1;
        } catch {
          page = pageUrl;
        }
      }
      const params = {
        search: this.searchQuery,
        start_date: this.startDate || '',
        end_date: this.endDate || '',
        page,
      };
      await this.$store.dispatch('remissions/fetchData', params);
      await this.fetchFilteredTotal();
    },
    async fetchFilteredTotal() {
      const params = {
        search: this.searchQuery,
        start_date: this.startDate || '',
        end_date: this.endDate || '',
      };
      const rows = await this.$store.dispatch('remissions/getAll', params);
      this.totalFilteredAllPages = (rows || []).reduce(
        (acc, item) => acc + parseFloat(item.total || 0),
        0
      );
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissions/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    /** Mismo flujo que POS: ticket a pantalla completa dentro de la app */
    async openPosTicket(remissionId) {
      try {
        await this.$router.push({
          name: "PosTicket",
          params: { id: String(remissionId) },
          query: { returnTo: "/remissions" },
        });
      } catch (error) {
        console.error("Error al abrir ticket:", error);
        const msg =
          error?.data?.message ||
          error?.response?.data?.message ||
          "No se pudo abrir el ticket.";
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: msg,
        });
      }
    },
    async exportToExcel() {
      try {
        // Preparar filtros para la exportación
        const filters = {};
        if (this.searchQuery) {
          filters.search = this.searchQuery;
        }
        if (this.startDate) {
          filters.start_date = this.startDate;
        }
        if (this.endDate) {
          filters.end_date = this.endDate;
        }

        // Llamar al servicio de exportación con los filtros
        const response = await this.$store.dispatch('remissions/exportData', filters);
        
        // Crear un objeto URL temporal para el archivo Excel
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace temporal para descargar el archivo
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ventas.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        
        // Limpiar el URL temporal
        window.URL.revokeObjectURL(url);
        
        await Swal.fire('Éxito', 'Archivo Excel exportado correctamente', 'success');
      } catch (error) {
        console.error('Error al exportar:', error);
        await Swal.fire('Error', 'No se pudo exportar el archivo Excel', 'error');
      }
    }
  },
  created() {
    this.debouncedFetchData = debounce(() => this.fetchData(null), 400);
  },
  mounted() {
    this.fetchData();
  },
  beforeUnmount() {
    if (this.debouncedFetchData) this.debouncedFetchData.cancel();
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}
</style>